__turbopack_context__.v({
  "countdown": "style-module-scss-module__dY4SWa__countdown",
  "resendButton": "style-module-scss-module__dY4SWa__resendButton",
});
